import { useState } from 'react';
import { ChevronDown, LifeBuoy } from 'lucide-react';
import Container from '../components/Container';
import SectionHeading from '../components/SectionHeading';
import { FAQ_ITEMS } from '../lib/faq';

export default function Help() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="help" className="scroll-mt-20">
      <section className="bg-gradient-to-b from-brand-green-50 to-surface py-16 sm:py-6">
        <Container>
          <SectionHeading
            eyebrow="Help & FAQ"
            title="Answers to common questions"
            subtitle="Can't find what you're looking for? Reach out to us directly and we will be happy to help."
            center
          />
        </Container>
      </section>

      <section className="py-16 sm:py-20">
        <Container className="max-w-3xl">
          <div className="divide-y divide-brand-green-100 rounded-xl border border-brand-green-100 bg-surface shadow-card">
            {FAQ_ITEMS.map((item, i) => {
              const open = openIndex === i;
              return (
                <div key={item.question}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    aria-expanded={open}
                  >
                    <span className="text-base font-semibold text-brand-green-900">{item.question}</span>
                    <ChevronDown className={`h-5 w-5 shrink-0 text-brand-gold-600 transition-transform ${open ? 'rotate-180' : ''}`} />
                  </button>
                  {open && (
                    <div className="px-6 pb-5">
                      <p className="leading-relaxed text-ink-500">{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-10 flex flex-col items-center gap-3 rounded-xl bg-brand-green-50 p-8 text-center">
            <LifeBuoy className="h-8 w-8 text-brand-green-700" />
            <h3 className="text-lg font-bold text-brand-green-900">Still need help?</h3>
            <p className="max-w-md text-sm text-ink-500">
              Send us a message and our team will get back to you as soon as possible.
            </p>
            <a
              href="#contact"
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-brand-green-700 px-6 py-2.5 text-sm font-semibold text-white shadow-card transition-colors hover:bg-brand-green-800"
            >
              Contact Us
            </a>
          </div>
        </Container>
      </section>
    </section>
  );
}
